import classNames from "classnames";
import { FC, useState } from "react";
import useOnKeyDownHandler from "../../hooks/useOnKeyDownHandler";
import Caption from "./Caption";
import Table from "./Table";
import styles from "./YearPicker.module.css";

interface YearPickerProps {
  year: number;
  onSelect: (value: number) => void;
  onMove: (key: keyof Duration, value: number) => void;
  onCancel: () => void;
}

const YearPicker: FC<YearPickerProps> = (props: YearPickerProps) => {
  const [initialValue] = useState(props.year);

  const base = props.year - (props.year % 10);

  const years = Array.from({ length: 12 }).reduce((rv: number[][], _, i) => {
    const row = Math.floor(i / 4);
    const column = i - row * 4;
    (rv[row] = rv[row] || [])[column] = base + i;
    return rv;
  }, []);

  useOnKeyDownHandler({
    arrowUp: (options) => props.onMove("years", options.shiftKey ? -10 : -4),
    arrowDown: (options) => props.onMove("years", options.shiftKey ? 10 : 4),
    arrowLeft: (options) => props.onMove("years", options.shiftKey ? -10 : -1),
    arrowRight: (options) => props.onMove("years", options.shiftKey ? 10 : 1),
    pageUp: () => props.onMove("years", -10),
    pageDown: () => props.onMove("years", 10),
    home: () => props.onMove("years", -props.year + base),
    end: () => props.onMove("years", base + 10 - props.year),
    enter: () => props.onSelect(props.year),
    escape: () => props.onSelect(initialValue),
  });

  return (
    <>
      <Caption
        captions={[
          {
            title: ((): string => {
              const mod = props.year % 12;
              const start = props.year - mod;
              return `${start} - ${start + 11}`;
            })(),
          },
        ]}
        navigateBack={() => props.onMove("years", -10)}
        navigateForward={() => props.onMove("years", 10)}
      />
      <Table
        body={
          <>
            {years.map((cells, rowIndex) => (
              <tr key={`year_picker_row_${rowIndex}`}>
                {cells.map((year, cellIndex) => (
                  <td
                    className={classNames(styles.cell, {
                      [styles.selected]: year == props.year,
                    })}
                    key={`year_picker_row_${rowIndex}_cell_${cellIndex}`}
                    onClick={() => props.onSelect(year)}
                  >
                    <div className={styles.year}>{year}</div>
                  </td>
                ))}
              </tr>
            ))}
          </>
        }
      ></Table>
    </>
  );
};

export default YearPicker;
